import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { IVideoResponse } from 'src/app/shared/models/video.model';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { SentinelService } from '@bannerflow/sentinel';

@Injectable({
  providedIn: 'root',
})
export class VideoApiService {
  public videoUploadApiUrl = `${ConfigService?.config?.API_URL}`;
  private readonly sentinelService = inject(SentinelService);

  constructor(private http: HttpClient) {}

  /**
   * POST video file
   */
  public uploadVideo(
    fileContent: Uint8Array,
    fileName: string,
    fileType: string,
  ): Observable<IVideoResponse> {
    try {
      const formData: FormData = new FormData();
      const arrayBuffer = fileContent.slice().buffer;
      const blobContnent: Blob = new Blob([arrayBuffer], { type: fileType });

      formData.append('file', blobContnent, fileName);

      const response: any = this.http.post(
        `${this.videoUploadApiUrl}api/videos`,
        formData,
      );

      return response;
    } catch (error) {
      this.sentinelService.error(error, {
        context: 'VideoApiService.uploadVideo',
      });
    }
  }
}
